import React from 'react'
import DrawerMenu from '../DrawerMenu'
import { Box, Stack, useColorModeValue } from '@chakra-ui/react'
import Logo from '../../uielements/Logo'
import LangSwitcher from '../../uielements/LangSwitcher'
import LightsToggle from '../../uielements/LightsToggle'

const MobileHeader = () => {
    return (
        <Box
            className={'mobileHeader'}
            bgColor={useColorModeValue('brand.white', 'brand.white')}
            px={[4, 4, 4, 4, 0]}
            py={[3, 4, 4, 4, 5]}
            pos={['fixed', 'fixed', 'fixed', 'fixed', 'relative']}
            top={[0, 0, 0, 0, 'auto']}
            left={[0, 0, 0, 0, 'auto']}
            right={[0, 0, 0, 0, 'auto']}
            zIndex={99}
        >
            <Stack direction={'row'} justifyContent={'space-between'} align={'center'}>
                <Stack direction={'row'} justifyContent={'flex-start'} align={'center'}>
                    <DrawerMenu />
                    <Logo width={'130px'} color={'blue'} />
                </Stack>
                <Stack direction={'row'} justifyContent={'flex-end'} align={'center'}>
                    <LangSwitcher />
                    {/*<LightsToggle />*/}
                </Stack>
            </Stack>
        </Box>
    )
}

export default MobileHeader
